import { areSame } from "@arrays-immutable";
import { useDataTableSelector } from "..";
import { GridStateWithSizes } from "./DataColumnResizer.actions";

const COLUMN_SELECTOR = <S>(s: GridStateWithSizes<S>) => s.columnSizes;
export const useFixedColumnSizes = () => {
  return useDataTableSelector(COLUMN_SELECTOR, areSame) ?? [];
};
